import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getDurationHourMinSecStr, getNiceDate } from '@iotv/datamodel-core';
import { Skeleton, Stack, Typography } from '@mui/material';
import { SimpleTreeView, TreeItem2 } from '@mui/x-tree-view';
import { useContext, useEffect, useState } from 'react';
import { AppMainViewContext } from '../../../../ContextProviders/AppContextProvider';
import { CoverageReportContext } from '../../Contexts';
import { getCoverageReportSk } from '../../ResultRetrieval/hooks/useCoverage';
export const CoverageReportSelector = ({}) => {
    // main app state
    const [{ isSmallView }] = useContext(AppMainViewContext);
    // all reports state
    const coverageReportState = useContext(CoverageReportContext);
    const { retrievingReports, selectedReports, setSelectedReports } = coverageReportState;
    const coverageReportMap = coverageReportState.coverageReportMap;
    // local coverage reports tree
    const [reportsTree, setReportsTree] = useState({});
    useEffect(() => {
        const tree = {};
        Object.values(coverageReportMap).map((reports) => reports.forEach((report, i) => {
            const formatted = `${getNiceDate(report.timePeriod.toDateMs)} (${getDurationHourMinSecStr(report.timePeriod.toDateMs - report.timePeriod.fromDateMs).trim()})`;
            if (tree[formatted] === undefined)
                tree[formatted] = [report];
            else {
                // check if there is already a report for this object
                const i = tree[formatted].findIndex((r) => r.GeoObject.id === report.GeoObject.id);
                if (i !== -1) {
                    const existing = tree[formatted][i];
                    // only keep the latest report
                    if (existing.created <= report.created) {
                        tree[formatted].splice(i, 1, report);
                    }
                }
                else {
                    tree[formatted].push(report);
                }
            }
        }));
        const sortedDates = Object.keys(tree).sort((dateStringA, dateStringB) => Date.parse(dateStringB) - Date.parse(dateStringA));
        const sortedTree = Object.fromEntries(sortedDates.map((date) => [date, tree[date]]));
        setReportsTree(sortedTree);
    }, [coverageReportMap]);
    return (_jsxs(Stack, { width: isSmallView ? undefined : '20dvw', height: '70cqh', overflow: 'auto', children: [_jsx(Typography, { variant: "h5", paddingInlineStart: 1, children: "Select a report" }), _jsxs(SimpleTreeView, { disableSelection: retrievingReports, checkboxSelection: true, onItemSelectionToggle: (_, id, selected) => (selected ? setSelectedReports(reportsTree[id].map(getCoverageReportSk)) : setSelectedReports([])), children: [Object.entries(reportsTree).map(([date, reports]) => {
                        return (_jsx(TreeItem2, { itemId: date, label: date, children: _jsx(SimpleTreeView, { checkboxSelection: true, multiSelect: true, disableSelection: true, disabledItemsFocusable: true, selectedItems: selectedReports, onSelectedItemsChange: (_, items) => {
                                    setSelectedReports(items);
                                }, children: reports.map((report, i) => {
                                    const sk = getCoverageReportSk(report);
                                    return _jsx(TreeItem2, { itemId: sk, label: report.GeoObject.name }, sk);
                                }) }) }, date));
                    }), retrievingReports && _jsx(Skeleton, { variant: "rounded", height: '1.75em', width: '100%' })] })] }));
};
